/* unplugin-vue-components disabled */import script from "./vip.vue?vue&type=script&setup=true&lang=js"
export * from "./vip.vue?vue&type=script&setup=true&lang=js"

import "./vip.vue?vue&type=style&index=0&id=0c94bf18&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c94bf18"]])

export default __exports__